import { ButtonIcon } from '@delmonicos/shared-design-system-react/src/components/button-icon/button-icon';
import { ButtonColor } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import * as cssTable from '@delmonicos/shared-design-system-react/src/components/table/table.module.scss';
import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';

export interface RoleListActionsCellProps
  extends CellContext<GatewayRoleModel, unknown> {}

export const RoleListActionsCell = (
  props: RoleListActionsCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;
  const navigate = useNavigate();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  const canRead =
    userPermissions &&
    hasAccessTo(userPermissions, {
      resourceName: Resource.ROLES,
      action: ActionsByResource.ROLES.READ,
    });

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-end">
      {canRead && (
        <ButtonIcon
          color={ButtonColor.Ghost}
          icon="eye"
          onClick={() =>
            navigate(
              generatePath(APP_PATH.ROLE.DETAILS, { id: row.original.id }),
            )
          }
          className={cssTable.displayOnHover}
        />
      )}
    </Stack>
  );
};
